import { FC, FormEvent, useEffect } from 'react'
import { disablePageScroll, enablePageScroll } from 'scroll-lock'
import { Mark, SCMark } from '../../assets'
import { setShowAuthModal, useAppDispatch, useAppSelector } from '../../redux'
import { ROUTES, handleEnterToNextInput, useRegister } from '../../utils'
import { Spinner } from '..'
import { StyledAuthDialog } from '.'

const AuthDialog: FC = () => {
  const dispatch = useAppDispatch()
  const { form, loading, set, register } = useRegister()
  const { showAuthModal, authRedirect } = useAppSelector((state) => state.state)

  const handleSubmit = (e?: FormEvent) => {
    if (loading) return

    e?.preventDefault()
    register()
  }

  useEffect(() => {
    set({
      fullName: '',
      email: '',
      password: '',
      text: false,
      phone: '',
      plan: 'trial'
    })

    if (showAuthModal) {
      return disablePageScroll()
    }

    enablePageScroll()
  }, [showAuthModal])

  if (!showAuthModal) {
    return null
  }

  return (
    <StyledAuthDialog>
      <div className="backdrop" onClick={() => dispatch(setShowAuthModal(false))} />
      <div className="dialog">
        <div className="icon">
          <Mark />
        </div>
        <span className="title">Social Curator Academy</span>
        <span className="description">Create an account to purchase this course</span>
        <form onSubmit={(e) => handleSubmit(e)}>
          <div className="register-form">
            <div className="fields">
              <label>
                <input
                  placeholder="Full Name"
                  value={form.fullName}
                  name="fullName"
                  type="text"
                  required={true}
                  onChange={(e) => set('fullName', e.target.value)}
                  onKeyDown={(e) => handleEnterToNextInput(e)}
                />
              </label>
              <label>
                <input
                  placeholder="Email Address"
                  value={form.email}
                  name="email"
                  type="email"
                  required={true}
                  onChange={(e) => set('email', e.target.value)}
                  onKeyDown={(e) => handleEnterToNextInput(e)}
                />
              </label>
              <label>
                <input
                  placeholder="Password"
                  value={form.password}
                  name="password"
                  type="password"
                  required={true}
                  onChange={(e) => set('password', e.target.value)}
                />
              </label>
            </div>
            <button className="register-btn auth-btn" type="submit" disabled={loading}>
              {!loading && 'Continue'}
              {loading && <Spinner />}
            </button>
          </div>
          <div className="or-sep">
            <span>OR</span>
          </div>
          <a
            href={`${ROUTES.external.auth}&redirect=${encodeURIComponent(
              authRedirect || window.location.href
            )}`}
            aria-disabled={loading}
            className="login-btn auth-btn"
            onClick={() => dispatch(setShowAuthModal(false))}
          >
            <SCMark />
            Log in with Social Curator
          </a>
        </form>
      </div>
    </StyledAuthDialog>
  )
}

export default AuthDialog
